import { ADD_CONNECTED_ACCOUNT_ID } from '../actions/actions';

const addConnectedAccountId = (payload) => {
    console.log("incoming payload connected:", payload);
    return {
        type: ADD_CONNECTED_ACCOUNT_ID,
        payload: payload
    }
}

export default addConnectedAccountId;